<template>
  <portal
    to="loading-portal"
    :disabled="!usePortal"
  >
    <div
      v-show="isLoading"
      id="loading-block"
    >
      <div
        class="loading-block "
        style="background-color: #f7f7f785;"
      >
        <font-awesome-icon
          class="icone-loading "
          icon="fa-spin fas fa-spinner"
          size="5x"
          style="color: var(--primary);"
        />
        <h4 class="loading_titulo">
          {{ tituloCarregamento }}
        </h4>
        <h4 class="loading_descricao">
          {{ descricao }}
        </h4>
      </div>
      <b-button
        v-if="showCancelButton"
        variant="danger"
        class="button-cancel"
        @click="cancelar()"
      >
        Cancelar
      </b-button>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    cancelarUpload: {
      type: Function,
      default: () => {},
    },
    showCancelButton: {
      type: Boolean,
      default: () => true,
    },
    tituloCarregamento: {
      type: String,
      default: () => '',
    },
    descricao: {
      type: String,
      default: () => '',
    },
    usePortal: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    cancelar() {
      this.cancelarUpload()
    },
  },
}
</script>
